import { Button } from "@src/appV2/redesign/components/Button";

interface ExtendShiftActionProps {
  onExtendShift: () => void;
}

export function ExtendShiftAction(props: ExtendShiftActionProps) {
  const { onExtendShift } = props;

  return (
    <Button variant="outlined" startIconType="clock" onClick={onExtendShift}>
      Extend shift
    </Button>
  );
}
